<template>
  <div :style="{'paddingTop':paddingTop}" class="no-data">
    <img src='~@/assets/img/profile/kongbai.png' alt="">
    <span class="title">{{content}}</span>
    <div v-if="html" v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: {
    content: {
      type: String,
      default() {
        return "该条件下暂无数据,请您尝试更换筛选条件!";
      }
    },
    paddingTop: {
      type: String,
      default() {
        return "100px";
      }
    },
    html: {}
  }
};
</script>

<style lang="less" scoped>
.no-data {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    margin-top: 20px;
    color: #24ba58;
    font-size: 20px;
    letter-spacing: 0.2em;
    user-select: none;
  }
}
</style>